module.exports = __webpack_public_path__ + "img/H2.b7f8db27.png";